import { Box, Divider, List, ListItem, ListItemText, Paper, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { DataGrid } from '@mui/x-data-grid'
import React, { FC, useState } from 'react'
import { connect } from 'react-redux'
import { MarkupPropsType, MarkupType } from '../../../api/appAPI'
import { StateType } from '../../../redux/store'
import { EnqueueSnackbarType } from '../../common/Helpers'
import EditMarkup from './EditMarkup'
import DefineMarkup from './DefineMarkup'
import { addMarkup, editMarkup } from '../../../redux/itemReducer'

interface IProps {
    markups: MarkupType[]

    addMarkup(markupProps: MarkupPropsType, enqueueSnackbar: EnqueueSnackbarType): void
    editMarkup(id: number, markup: MarkupPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const MarkupTab: FC<IProps> = props => {
    const [activeMarkup, setActiveMarkup] = useState<undefined | MarkupType>(undefined)

    return (
        <Box
            display='flex'
            style={{ height: window.innerHeight - 48 * 2 }}
        >
            <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                pt={2}
                style={{ borderRight: 'solid 1px black', width: '50%' }}
            >
                <Typography variant='h6'>Markup List</Typography>

                <Paper style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}>
                    <List component="nav" style={{ padding: 0 }}>
                        <ListItem button onClick={() => {
                            // props.setActiveMaterialId(0) 
                            setActiveMarkup(undefined)
                        }}>
                            <ListItemText primary='New Markup' />
                            <AddIcon />
                        </ListItem>
                        <Divider />
                    </List>

                </Paper>
                <DataGrid
                    style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}
                    columns={[
                        { field: 'id', },
                        { field: 'name', headerName: 'Name', minWidth: 200 },
                        { field: 'value', headerName: 'Value', width: 200 },
                    ]}
                    // hideFooterPagination
                    rows={props.markups.map(markup => ({
                        id: markup.id,
                        name: markup.name,
                        value: markup.value,
                    }))}
                    onRowClick={(param) => {
                        setActiveMarkup(props.markups.find(m => m.id === parseInt(param.id.toString())))
                    }}

                />
            </Box>
            {activeMarkup === undefined
                ? <DefineMarkup addMarkup={props.addMarkup} />
                : <EditMarkup markup={activeMarkup} editMarkup={props.editMarkup} />
            }
        </Box>
    )
}

const mapStateToProps = (state: StateType) => ({
    markups: state.itemReducer.markups,
})

export default connect(mapStateToProps, {
    addMarkup,
    editMarkup
})(MarkupTab)